import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { localize } from 'helpers/translator'
import TextLink from 'components/text_link/text_link'
import { MainButton, CancelButton } from 'components/button'

import styles from './add_to_folder.scss'
// import FolderPlaceholder from '../../assets/loaders/folder_placeholder.svg'

class AddToFolder extends Component {

	constructor() {
		super()
		this.addLesson = this.addLesson.bind(this)
		this.selectFolder = this.selectFolder.bind(this)
		this.state = {
			selected: -1,
		}
	}

	getFolders() {
		const folders = this.props.folders.map(item => <li styleName={
			classNames({
				'results-list-item': true,
				'results-list-item--selected': item.id === this.state.selected,
			})
		}
		key={item.id}
		onClick={() => this.selectFolder(item.id)}>
			<svg height='14' width='19'> <path styleName='color-change' d='M18.49 2.06H8.02L5.97.16C5.85.06 5.71 0 5.56 0H.71C.37 0 0 .17 0 .51v12.77c0 .34.37.72.71.72h17.78c.34 0 .51-.38.51-.72V2.57c0-.34-.17-.51-.51-.51z' fill='#b8c0c6'/></svg>
			<h2 styleName='results-list-item-folder-name'>{item.name}</h2>
			<span styleName='results-list-item-check'></span>
		</li>)
		return folders
	}

	addLesson() {
		this.props.saveLesson(this.state.selected)
	}

	selectFolder(id) {
		this.setState({selected: id})
	}

	render() {
		return (<div styleName='wrapper'>
			<h2 styleName='title'>{this.props.modalTitle}</h2>
			<ul styleName='results-list'>
				{/* TODO: Implementar folder placeholder mientras cargan
                <li styleName='results-list-item-placeholder'>
                    <img src={FolderPlaceholder} />
                </li>
                */}
				{this.getFolders()}
				{ this.props.folders.length === 0 && <li styleName='results-list-no-matches'>
					{localize('add_to_folder_result_list_no_matches')},&nbsp;
					<div styleName='results-list-no-matches-link'><TextLink onClick={this.props.createNewFolder}>{localize('add_to_folder_result_list_no_matches_link')}</TextLink></div>
				</li> }
			</ul>
			<div styleName='new-folder-link'>
				<TextLink onClick={this.props.createNewFolder}>{this.props.createNewText}</TextLink>
			</div>
			<div styleName='btn-bar'>
				<div styleName='btn-bar-container'>
					<CancelButton type='button' onClick={this.props.cancel}>{localize('global_cancel')}</CancelButton>
				</div>
				<div styleName='btn-bar-container'>
					<MainButton onClick={this.addLesson} disabled = {this.state.selected === -1}>{localize('add_to_folder_add_lessons')}</MainButton>
				</div>
			</div>
		</div>)
	}
}

AddToFolder.defaultProps = {
	modalTitle: localize('add_to_folder_title'),
	createNewText: localize('add_to_folder_new_folder_link'),
}

export default CSSModules(AddToFolder, styles, { allowMultiple: true })
